<template lang='pug'>
    div
        PDaccessoriesSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title CAL-IEC Accessory Kit
                h2.product-subtitle Robust carrying case with cables, clamps, and connectors for the CAL-IEC calibrator

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-Case.webp')
                            img( src='@/assets/photos/product_shots/CAL-IEC-Case.png', width="70%", alt='CAL-IEC Accessory Kit', title='CAL-IEC Accessory Kit')
                        
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Complete accessory kit for quick and reliable CAL-IEC connection
                                li Includes cables, adapters, and clamps for flexible on-site use
                                li Extra-long cables for easy injection into overhead lines or busbars
                                li Clearly organized case for fast access and safe transport
                                li Compatible with standard BNC and N interfaces
                                li Suitable for laboratory and field measurement applications
                            
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet CAL-IEC Accessory Kit.pdf")
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/cal-iec", text='CAL-IEC PD Calibrator')

            section.margin-bottom
                .column-container
                    .column
                        p The accessory kit complements the CAL-IEC calibrator to form a ready-to-use solution for laboratory and field applications. The carefully selected connection cables and adapters enable flexible connection possibilities to cover all conditions encountered during field operation.
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Accessory.webp')
                            img( src='@/assets/photos/for_product_overview/CAL-IEC-Accessory.png', width="100%", alt='Calibrator Accessory', title='Calibrator Accessory')
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case_closed.webp')
                            img( src='@/assets/photos/for_product_overview/CAL-IEC-Case_closed.png', width="70%", alt='CAL-IEC Accessory Kit Case', title='CAL-IEC Accessory Kit Case')
                    .column
                        p The robust carrying case provides ample space for the CAL-IEC calibrator and all accessories, while reliably protecting the components during transport. Its clearly structured interior layout allows quick identification and easy access to the required parts.
                

        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title CAL-IEC Zubehörset
                h2.product-subtitle Robuster Tragekoffer mit Kabeln, Klemmen und Adaptern für den CAL-IEC Signalgenerator

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-Case.webp')
                            img( src='@/assets/photos/product_shots/CAL-IEC-Case.png', width="70%", alt='Sensorkoffer für UHF-Sensoren', title='Sensorkoffer für UHF-Sensoren')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Komplettes Zubehörset für schnellen und zuverlässigen Anschluss des CAL-IEC
                                li Enthält Kabel, Adapter und Klemmen für den flexiblen Einsatz vor Ort
                                li Extra-lange Kabel für die einfache Einspeisung in Freileitungen oder Sammelschienen
                                li Klar organisierter Koffer für schnellen Zugriff und sicheren Transport
                                li Kompatibel mit Standard BNC- und N-Anschlüssen
                                li Geeignet für Labor- und Feldmessanwendungen
                            
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet CAL-IEC Accessory Kit.pdf")
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/cal-iec", text='CAL-IEC TE-Kalibrator')

            section.margin-bottom
                .column-container
                    .column
                        p Das Zubehörset ergänzt den CAL-IEC Kalibrator zu einer sofort einsatzbereiten Lösung für Labor- und Feldeinsätze. Die praxisgerecht ausgewählten Anschlusskabel und Adapter ermöglichen flexible Anschlussmöglichkeiten für alle im Feldeinsatz auftretenden Bedingungen.
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Accessory.webp')
                            img( src='@/assets/photos/for_product_overview/CAL-IEC-Accessory.png', width="100%", alt='CAL-IEC Zubehörset', title='CAL-IEC Zubehörset')
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case_closed.webp')
                            img( src='@/assets/photos/for_product_overview/CAL-IEC-Case_closed.png', width="70%", alt='CAL-IEC Accessory Kit Case', title='CAL-IEC Accessory Kit Case')
                    .column
                        p Der robuste Transportkoffer bietet ausreichend Platz für den CAL-IEC Kalibrator und sämtliches Zubehör und schützt die Komponenten zuverlässig während des Transports. Die klar strukturierte Innenaufteilung ermöglicht eine schnelle Identifikation und einen einfachen Zugriff auf die benötigten Teile.
                        
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Kalibrator Zubehörset",
            description: "Tragekoffer für Signalgeneratoren und Kalibratoren",
        },
        en: {
            title: "BSS | Calibrator Accessory Kit",
            description: "Hard-carry-case for Signal Generators and Calibrators",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>